import backBtn from "../../assets/icons/back-btn.png";
import logo from "../../assets/doctio-logo.svg";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import FeatureTableBox from "../Priser/FeatureTableBox";
import PaymentPopup from "./PaymentPopup";
import { useNavigate } from "react-router-dom";
import FeatureTableBoxSP from "../Priser/FeatureTableBoxSP";
import Select from "react-tailwindcss-select";
import { SelectValue } from "react-tailwindcss-select/dist/components/type";
import { ToastContainer, toast } from "react-toastify";
import countriesData from "../../assets/countries/countries.json";

declare global {
  interface Window {
    Reepay: any;
  }
}

type Option = {
  value: string;
  label: string;
  disabled?: boolean;
};

const Reepay = window.Reepay;

export default function ChooseSubscription({
  prevStep,
  isSundhedsperson,
  activationId,
}: {
  prevStep: any;
  isSundhedsperson: boolean;
  activationId: string;
}) {
  const navigate = useNavigate();
  const [countries, setCountries] = useState<any>([]);
  const [country, setCountry] = useState<Option | null>(null);
  const [formData, setFormData] = useState({
    fornavn: "",
    efternavn: "",
    email: "",
    telefonnummer: "",
    firmanavn: "",
    land: "",
    adresse: "",
    postnummer: "",
    by: "",
    kode: "",
    confirm_conditions: false,
  });

  const handleCountryChange = (value: SelectValue) => {
    if (value && typeof value === "object") {
      const selectedOption = value as Option;
      setCountry(selectedOption);
      setFormData({
        ...formData,
        land: selectedOption.value,
      });
    }
  };

  useEffect(() => {
    console.log("countries", countriesData);
    setCountries(countriesData);
    setFormData((prevFormData) => ({
      ...prevFormData,
      land: "DK",
    }));
  }, []);

  const [sessionId, setSessionId] = useState("");
  const [isYearly, setIsYearly] = useState(true);
  const [checkoutInstance, setCheckoutInstance] = useState<any | null>(null);
  const [isPro, setIsPro] = useState(true);
  const [tooltip1, setTooltip1] = useState(false);
  const [tooltip2, setTooltip2] = useState(false);

  const tooltip1Ref = useRef<HTMLDivElement | null>(null);
  const tooltip2Ref = useRef<HTMLDivElement | null>(null);

  const closeTooltips = () => {
    setTooltip1(false);
    setTooltip2(false);
  };

  const toggleTooltip1 = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    closeTooltips();
    setTooltip1(!tooltip1);
  };

  const toggleTooltip2 = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    closeTooltips();
    setTooltip2(!tooltip2);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        tooltip1Ref.current &&
        !tooltip1Ref.current.contains(event.target) &&
        tooltip2Ref.current &&
        !tooltip2Ref.current.contains(event.target)
      ) {
        console.log("click outside");
        closeTooltips();
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleSubscriptionType = () => {
    setIsPro(!isPro);
  };

  const handlePaymentRate = () => {
    setIsYearly(!isYearly);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.checked,
    });
  };

  const handleNextButtonClick = () => {
    if (isPro) {
      const checkoutInstance = new Reepay.ModalSubscription();
      setCheckoutInstance(checkoutInstance);

      fetch(`https://test.doctio.dk/api/activations/${activationId}/session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          cycle: isYearly ? "annual" : "monthly",
          customer: {
            first_name: formData.fornavn,
            last_name: formData.efternavn,
            email: formData.email,
            phone: formData.telefonnummer,
            address: formData.adresse,
            postal_code: formData.postnummer,
            city: formData.by,
            country: formData.land,
            company: formData.firmanavn,
            vat: "test",
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          setSessionId(data.id);
          checkoutInstance.show(data.id, { showReceipt: false });
        })
        .catch((error) => {
          toast.error("Der skete en fejl. Prøv igen senere.");
          console.error("Error fetching Reepay session id:", error);
        });
    } else {
      navigate("/confirmation", {
        state: {
          isPro,
          isYearly,
          name: formData.fornavn + " " + formData.efternavn,
          adress: formData.adresse,
        },
      });
    }
  };

  const isFormValid = () => {
    return (
      formData.fornavn &&
      formData.efternavn &&
      formData.email &&
      formData.adresse &&
      formData.postnummer &&
      formData.by &&
      formData.confirm_conditions
    );
  };

  return (
    <div className="overflow-hidden">
      <section className="md:h-screen">
        <div className="grid mx-auto md:h-full md:grid-cols-2">
          <div className="overflow-auto">
            <div className="bg-white container md:w-2/3 mx-auto md:py-6">
              <div className="header mt-2 mb-10 md:mb-0 flex flex-row-reverse md:block items-center justify-between">
                <button
                  className="flex items-center md:mb-24"
                  onClick={() => prevStep()}
                >
                  <img
                    src={backBtn}
                    width={26}
                    className="mr-3"
                    alt="Tilbage"
                  />
                  <p className="text-doctio-green">Tilbage</p>
                </button>
                <Link to="/">
                  <img
                    src={logo}
                    width={150}
                    className="md:mr-3 md:mb-20 w-[120px] md:w-[150px]"
                    alt="Logo"
                  />
                </Link>
              </div>

              <h1 className="text-dxl mb-20 font-bold leading-tight tracking-tight text-doctio-green md:text-d2xl">
                Vælg abonnement
              </h1>

              <div className="flex relative">
                <h4 className=" font-bold mb-6 leading-tight tracking-tight">
                  Vælg abonnement
                </h4>

                {isSundhedsperson && (
                  <>
                    <div
                      ref={tooltip1Ref}
                      className={`tooltip-content ${
                        tooltip1 ? "" : "hidden"
                      } absolute z-50 overflow-wrap break-word font-medium whitespace-normal h-fit text-doctio-dark w-[calc(100vw-29px)] md:w-[435px] rounded-2xl top-[30px]  bg-white p-4 shadow-md `}
                    >
                      <p className="m-0">
                        Doctio Basic abonnementet indeholder reklamer for
                        receptligtig medicin. Jf. lægemiddellovens § 66, stk. 1,
                        nr. 1, må der ikke reklameres for receptligtige
                        lægemidler over for offentligheden. Ved offentligheden
                        forstås enhver, der ikke er læge, tandlæge, farmaceut,
                        sygeplejerske, farmakonom, jordemoder, bioanalytiker,
                        klinisk diætist, radiograf, social- og sundhedsassistent
                        eller studerende indenfor et af disse fag, jf.
                        lægemiddellovens § 66, stk 2. Da du har valgt en anden
                        fagprofil end den listede, har du derfor kun tilladelse
                        til at anvende Doctio Pro uden reklamer.
                      </p>
                    </div>
                    <svg
                      fill="#415779"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20.2 20.2"
                      onClick={(e) => toggleTooltip1(e)}
                      className="info-boks cursor-pointer ml-4 md:mr-0"
                      width="20px"
                      height="20px"
                    >
                      <g id="Info-icon" transform="translate(0.1 0.1)">
                        <path
                          id="Icon_metro-info"
                          data-name="Icon metro-info"
                          d="M11.321,7.866a.94.94,0,0,1,.938-.937h.625a.94.94,0,0,1,.937.938v.625a.94.94,0,0,1-.937.938h-.625a.94.94,0,0,1-.938-.937Zm3.75,9.063h-5v-1.25h1.25v-3.75h-1.25v-1.25h3.75v5h1.25Zm-2.5-15a10,10,0,1,0,10,10,10,10,0,0,0-10-10Zm0,18.125A8.125,8.125,0,1,1,20.7,11.928,8.125,8.125,0,0,1,12.571,20.053Z"
                          transform="translate(-2.571 -1.928)"
                          fill="#415779"
                          stroke="#fff"
                          stroke-width="0.2"
                        />
                      </g>{" "}
                    </svg>
                  </>
                )}
              </div>

              <div>
                <div className="flex">
                  <div className="flex  items-center w-[140px]">
                    <input
                      checked={!isPro}
                      id="default-radio-1"
                      disabled={isSundhedsperson}
                      type="radio"
                      value=""
                      onChange={handleSubscriptionType}
                      name="default-radio"
                      className={`${
                        isSundhedsperson ? "opacity-50" : ""
                      } w-8 h-8 mr-4 text-doctio-green accent-green-800 bg-gray-100 border-gray-300 focus:ring-green-800`}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className={`ms-2 ${
                        isSundhedsperson ? "opacity-50" : ""
                      } font-medium text-gray-900`}
                    >
                      Doctio Basic
                    </label>
                  </div>
                  <p
                    className={`italic text-dsm ${
                      isSundhedsperson ? "opacity-50" : ""
                    } md:ml-8`}
                  >
                    Gratis
                  </p>
                </div>
                <div className="flex mt-3">
                  <div className="flex w-[140px]">
                    <div className="flex items-center">
                      <input
                        id="default-radio-2"
                        type="radio"
                        checked={isPro}
                        value=""
                        onChange={handleSubscriptionType}
                        name="default-radio"
                        className="w-8 h-8 mr-4 text-doctio-green bg-gray-100 accent-green-800 border-gray-300 focus:ring-green-800"
                      />
                      <label
                        htmlFor="default-radio-2"
                        className="ms-2 font-medium text-gray-900"
                      >
                        Doctio Pro
                      </label>
                    </div>
                  </div>
                  <label className="md:ml-8 relative justify-center flex cursor-pointer select-none items-start">
                    <input
                      type="checkbox"
                      checked={isYearly}
                      onChange={handlePaymentRate}
                      className="sr-only"
                    />
                    <div
                      className={`label flex italic flex-col items-center text-dsm font-medium ${
                        isYearly ? "opacity-50" : "text-black"
                      }`}
                    >
                      <p className="m-0">179,-/md</p>
                    </div>
                    <span className="slider mx-6 italic flex h-8 w-[45px] rounded-full p-1 duration-200 bg-doctio-green">
                      <span
                        className={`dot h-6 w-6 rounded-full bg-white duration-200 ${
                          isYearly ? "translate-x-[24px]" : ""
                        }`}
                      ></span>
                    </span>
                    <div
                      className={`label flex flex-col relative items-center text-dsm font-medium ${
                        !isYearly ? "opacity-50" : "text-black"
                      }`}
                    >
                      <span className="bg-doctio-green absolute top-[-24px] right-[-15px] text-white text-[12px] font-semibold me-2 px-2.5 py-1 rounded">
                        Spar 10%
                      </span>
                      <p className="m-0">1933.20 -/år</p>
                    </div>
                  </label>
                </div>
              </div>

              <h4 className=" mt-12 font-bold leading-tight tracking-tight">
                Faktureringsoplysninger
              </h4>

              <form className="space-y-6 signup-form mt-6">
                <div className="grid gap-4 grid-cols-2">
                  <input
                    type="text"
                    name="fornavn"
                    id="fornavn"
                    placeholder="Fornavn"
                    value={formData.fornavn}
                    onChange={handleInputChange}
                    className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-6"
                  />
                  <input
                    type="text"
                    name="efternavn"
                    id="efternavn"
                    placeholder="Efternavn"
                    value={formData.efternavn}
                    onChange={handleInputChange}
                    className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-6"
                  />
                </div>
                <div>
                  <input
                    type="email"
                    name="email"
                    id="emailsignup"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-6"
                  />
                </div>
                <div>
                  <input
                    type="tel"
                    name="telefonnummer"
                    id="telefonnummer"
                    placeholder="Telefonnummer (valgfrit)"
                    value={formData.telefonnummer}
                    onChange={handleInputChange}
                    className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-6"
                  />
                </div>
                <div>
                  <input
                    type="text"
                    name="firmanavn"
                    id="firmanavn"
                    placeholder="Firmanavn (valgfrit)"
                    value={formData.firmanavn}
                    onChange={handleInputChange}
                    className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-6"
                  />
                </div>
                <div>
                  <Select
                    value={country}
                    onChange={(value) => handleCountryChange(value)}
                    options={countries}
                    placeholder="Land"
                    isSearchable={true}
                    searchInputPlaceholder="Søg efter land"
                    noOptionsMessage="Ingen resultater fundet"
                    primaryColor={"emerald"}
                    classNames={{
                      searchIcon: "absolute w-5 h-5 pb-0.5 ml-2 text-gray-500",
                      searchContainer: "relative flex items-center py-1 px-2.5",
                      searchBox:
                        "w-full py-2 pl-8 text-dsm text-gray-500 bg-gray-100 border border-gray-200 rounded focus:border-gray-200 focus:ring-0 focus:outline-none",
                      menu: "absolute z-10 w-full bg-white shadow-lg border rounded py-1 mt-1.5 text-dsm text-gray-700",
                      menuButton: () =>
                        `flex sm:text-dsm px-4 ${
                          country ? "text-gray-900" : "text-[#9aa4b5]"
                        } border rounded shadow-sm transition-all duration-300 focus:outline-none bg-white hover:doctio-grey-border focus:border-blue-500 focus:ring focus:ring-blue-500/20"`,
                    }}
                  />
                </div>
                <div>
                  <input
                    type="text"
                    name="adresse"
                    id="adresse"
                    placeholder="Adresse"
                    value={formData.adresse}
                    onChange={handleInputChange}
                    className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-6"
                  />
                </div>

                <div className="grid gap-4 grid-cols-2">
                  <input
                    type="text"
                    name="postnummer"
                    id="postnummer"
                    placeholder="Postnummer"
                    value={formData.postnummer}
                    onChange={handleInputChange}
                    className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-6"
                  />
                  <input
                    type="text"
                    name="by"
                    id="by"
                    placeholder="By"
                    value={formData.by}
                    onChange={handleInputChange}
                    className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-6"
                  />
                </div>
              </form>

              <h4 className=" mt-10 mb-6 font-bold leading-tight tracking-tight">
                Rabatkupon
              </h4>

              <form className="signup-form">
                <div>
                  <input
                    type="text"
                    name="kode"
                    id="kode"
                    placeholder="Kode (valgfrit)"
                    value={formData.kode}
                    onChange={handleInputChange}
                    className="border border-[#E8E2DE]  text-gray-900 sm:text-dsm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full md:w-1/2 p-6 mr-2"
                  />
                </div>
              </form>

              <h4 className=" mt-10 mb-6 font-bold leading-tight tracking-tight">
                Ordreinformation
              </h4>

              <form>
                <div className="border rounded-2xl border-[#E8E2DE] px-6 py-3">
                  <p>Doctio {isPro ? "Pro" : "Basic"}</p>
                  <p>
                    {isPro ? (isYearly ? "1933,33" : "179") : "0"} DKK (inkl.
                    moms) pr. {isYearly ? "år" : "måned"}
                  </p>
                  <p>{isPro ? "Prøveperiode: 14 dage" : ""}</p>
                </div>
              </form>

              <div className="flex mt-10 items-center">
                <input
                  id="confirm_conditions"
                  name="confirm_conditions"
                  type="checkbox"
                  checked={formData.confirm_conditions}
                  onChange={handleCheckboxChange}
                  className="w-7 h-7 mr-2 accent-green-800 rounded focus:ring-green-800"
                />
                <p className="text-dsm font-light ml-3 text-gray-900">
                  Jeg har læst og accepteret{" "}
                  <Link
                    to="/betingelser"
                    className="underline inline text-doctio-green"
                  >
                    abonnements-betingelserne
                  </Link>
                </p>
              </div>

              <button
                type="button"
                disabled={!isFormValid()}
                onClick={handleNextButtonClick}
                style={{ opacity: isFormValid() ? 1 : 0.6 }}
                className="text-white mb-12 md:mb-0 mt-10 transition-colors w-full duration-300 ease-in-out font-bold rounded-full bg-doctio-green hover:bg-white hover:text-doctio-green hover:shadow-md focus:ring-4 focus:outline-none px-4 py-4 text-center mr-3 md:mr-0"
              >
                Næste
              </button>
            </div>
          </div>

          {sessionId && (
            <PaymentPopup
              sessionId={sessionId}
              onPaymentSuccess={(data) => {
                console.log("Payment success:", data);
                checkoutInstance.destroy();
                const overlayIdPattern = /rp_checkout_overlay_/;
                const overlayElements = document.querySelectorAll(
                  '[id^="rp_checkout_overlay_"]'
                );

                overlayElements.forEach((overlayElement) => {
                  if (
                    overlayIdPattern.test(overlayElement.id) &&
                    overlayElement.parentElement
                  ) {
                    overlayElement.parentElement.removeChild(overlayElement);
                  }
                });
                navigate("/confirmation", {
                  state: {
                    isPro,
                    isYearly,
                    name: formData.fornavn + " " + formData.efternavn,
                    adress: formData.adresse,
                  },
                });
              }}
              onPaymentError={(data) => {
                console.error("Payment error:", data);
                checkoutInstance.destroy();
              }}
              onPaymentCancel={(data) => {
                console.log("Payment canceled:", data);
              }}
              onModalClose={(data) => {
                console.log("Modal closed:", data);
              }}
            />
          )}

          <div className="bg-doctio-lightgreen relative hidden md:block h-screen  md:py-40">
            <div className="shadow-right"></div>
            <div className="container md:w-2/3 md:mx-auto">
              {isSundhedsperson ? (
                <>
                  <FeatureTableBox />
                  <p className="text-dsm flex items-end font-light mt-10 cursive">
                    <div>
                      <span className="font-bold">Abonnementstilladelse,</span>{" "}
                      Doctio Pro <br></br> Du har ikke tilladelse til at anvende
                      Doctio Basic{" "}
                    </div>
                    <div
                      ref={tooltip2Ref}
                      className={`tooltip-content ${
                        tooltip2 ? "" : "hidden"
                      } absolute z-50 overflow-wrap break-word font-medium whitespace-normal h-fit w-[calc(100vw-29px)] md:w-[435px] rounded-2xl bottom-[90px] left-[30%] bg-white p-4 shadow-md `}
                    >
                      <p className="m-0">
                        Doctio Basic abonnementet indeholder reklamer for
                        receptligtig medicin. Jf. lægemiddellovens § 66, stk. 1,
                        nr. 1, må der ikke reklameres for receptligtige
                        lægemidler over for offentligheden. Ved offentligheden
                        forstås enhver, der ikke er læge, tandlæge, farmaceut,
                        sygeplejerske, farmakonom, jordemoder, bioanalytiker,
                        klinisk diætist, radiograf, social- og sundhedsassistent
                        eller studerende indenfor et af disse fag, jf.
                        lægemiddellovens § 66, stk 2. Da du har valgt en anden
                        fagprofil end den listede, har du derfor kun tilladelse
                        til at anvende Doctio Pro uden reklamer.
                      </p>
                    </div>
                    <svg
                      fill="#415779"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20.2 20.2"
                      onClick={(e) => toggleTooltip2(e)}
                      className="info-boks cursor-pointer ml-4 md:mr-0"
                      width="20px"
                      height="20px"
                    >
                      <g id="Info-icon" transform="translate(0.1 0.1)">
                        <path
                          id="Icon_metro-info"
                          data-name="Icon metro-info"
                          d="M11.321,7.866a.94.94,0,0,1,.938-.937h.625a.94.94,0,0,1,.937.938v.625a.94.94,0,0,1-.937.938h-.625a.94.94,0,0,1-.938-.937Zm3.75,9.063h-5v-1.25h1.25v-3.75h-1.25v-1.25h3.75v5h1.25Zm-2.5-15a10,10,0,1,0,10,10,10,10,0,0,0-10-10Zm0,18.125A8.125,8.125,0,1,1,20.7,11.928,8.125,8.125,0,0,1,12.571,20.053Z"
                          transform="translate(-2.571 -1.928)"
                          fill="#415779"
                          stroke="#fff"
                          stroke-width="0.2"
                        />
                      </g>{" "}
                    </svg>
                  </p>
                </>
              ) : (
                <>
                  <FeatureTableBoxSP />
                </>
              )}
            </div>
          </div>
          <ToastContainer />
        </div>
      </section>
    </div>
  );
}
